import './SchoolBranchOfficer.scss'

import { DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Col, Input, notification, Row, Table } from 'antd'
import DeleteModal from 'components/okulyonetim-admin/delete-modal/DeleteModal'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AppContext from '../../../../context/AppContext'
import { useKampusYetkilisiSilMutation, useOkulKampusYetkilileriQuery } from '../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../spinner/Spinner'
const { Search } = Input

const SchoolBranchOfficer: React.FC = () => {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [searchValue, setSearchValue] = useState<string>('')
  const { okul } = useContext(AppContext)
  const { data, loading, refetch, error } = useOkulKampusYetkilileriQuery({
    variables: {
      sube_id: okul?.id,
      arama: searchValue || null,
    },
    fetchPolicy: 'network-only',
  })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
  const [deleteId, setDeleteId] = useState<string | null>(null)
  const [kampusYetkilisiSil] = useKampusYetkilisiSilMutation()
  const [submitting, setSubmitting] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const showDeleteModal = (ids: string[]) => {
    setDeleteId(ids.join(','))
    setIsDeleteModalVisible(true)
  }

  const handleDelete = async (ids: string) => {
    setSubmitting(true)
    const idList: number[] = ids.split(',').map((id) => Number(id))
    try {
      const response = await kampusYetkilisiSil({
        variables: {
          id: idList,
        },
      })
      if (response.data?.kampusYetkilisiSil.success) {
        notification.success({
          message: '',
          description: `${response.data?.kampusYetkilisiSil?.message}`,
          duration: 6,
        })
        setIsDeleteModalVisible(false)
        setSelectedRowKeys([])

        await refetch()
      } else {
        notification.error({
          message: '',
          description: `${response.data?.kampusYetkilisiSil?.message}`,
          duration: 6,
        })
      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    } finally {
      setSubmitting(false)
    }
  }

  // Filtreleme değiştikçe veriyi tekrar çek
  useEffect(() => {
    refetch()
  }, [searchValue, refetch])
  const handleSearch = () => {
    setSearchValue(searchTerm)
  }

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }
  if (submitting) {
    return <Spinner showSpinner={submitting} color="red" />
  }
  if (error) {
    console.error(error)
    navigate('/')
    return null
  }

  const filteredData = data?.okulKampusYetkilileri?.yetkil_kampusler?.filter(Boolean) ?? []
  const totalItems = filteredData.length;
  const displayedItems = selectedRowKeys.length;
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id',sorter: (a: any, b: any) => a.id - b.id, defaultSortOrder: 'descend' as 'descend' | 'ascend' | undefined, },
    { title: 'Yetkili', dataIndex: 'uye', key: 'uye' },
    { title: 'Şubeler', dataIndex: 'sube_isimler', key: 'sube_isimler' },
    {
      title: '',
      dataIndex: 'detay',
      key: 'detay',
      render: (_: string, record: any) => (
        <Button
          className="okul-yonetim-admin-detail-button"
          onClick={() => navigate(`/okulyonetimadmin/subeyetkilisi/${record.id}`)}
        >
          Detay
        </Button>
      ),
    },
  ]

  return (
    <div className="okul-yetkili-page">
      <div className="okul-sepeti-admin-header">
        <h1>Kampüs Yetkilileri </h1>
        <div className="button-right">
          <Button onClick={() => navigate('/okulyonetimadmin/subeyetkilisi/yetkili-ekle')}>Yetkili Ekle</Button>
        </div>
      </div>
      <Row gutter={8} className="filter-section">
        <Col span={6}>
          <Search
            placeholder="Yetkili Ara"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onSearch={handleSearch}
            allowClear
            enterButton={
              <div className="search-suffix-div">
                Ara <SearchOutlined />{' '}
              </div>
            }
          />
        </Col>
      </Row>

      <Table
        dataSource={filteredData as object[]}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          total: totalItems,
          showTotal: (total) => (
              <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                <Button
                    style={{
                      display: selectedRowKeys.length === 0 ? 'none' : '',
                    }}
                    icon={<DeleteOutlined/>}
                    onClick={() => showDeleteModal(selectedRowKeys.map((id) => id.toString()))}
                    type="primary"
                    danger
                >
                  Seçilen {selectedRowKeys.length} Kampus Yetkililerini Sil
                </Button>

                <span style={{marginLeft: '10px'}}> {/* Buton ile metin arasına boşluk koyuyoruz */}
                  Seçilen: {displayedItems} / Toplam: {total}
               </span>
              </div>
          ),
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
        loading={loading}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
        rowKey="id"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys,
          onChange: (keys) => setSelectedRowKeys(keys as string[]),
          ...Selection,
        }}
        className="okul-yonetim-admin-table"
      />
      <DeleteModal
        title="Seçilen Kampüs Yetkililerini Sil"
        id={deleteId || ''}
        visible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onDelete={handleDelete}
      />
    </div>
  )
}

export default SchoolBranchOfficer
